import React, { useState, useEffect } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { Link } from "react-router-dom"
import { Alert } from "@material-ui/lab"

const ErrorAccess = (props) => {
    const {
        errorComponent,
        message,
        subMessage,
        subMessageNormal,
        buttonText,
        buttonLink,
        buttonCallback,
        pageLoadAction,
        countDownPageAction,
        timer,
        countMessage,
    } = props
    const [callbackStatus, setCallbackStatus] = useState({
        error: null,
        errMsg: "",
        successMsg: "",
    })
    const messageOutput =
        message ||
        (errorComponent
            ? `Cannot access the section ${errorComponent}
        `
            : `Cannot access the section`)

    const runCallback = async () => {
        if (buttonCallback) {
            try {
                const result = await buttonCallback()
                const successMsg = result.data?.message
                setCallbackStatus({
                    error: false,
                    errMsg: ``,
                    successMsg,
                })
            } catch (error) {
                const errorMsg = error?.data?.message || "error"
                setCallbackStatus({
                    error: true,
                    errMsg: `${errorMsg}`,
                    successMsg: "",
                })
            }
        }
    }

    useEffect(() => {
        if (pageLoadAction) {
            pageLoadAction()
        }
    }, [pageLoadAction])

    const [counter, setCounter] = useState(timer / 1000)
    useEffect(() => {
        if (countDownPageAction && timer) {
            if (counter > 0) {
                setTimeout(() => setCounter(counter - 1), 1000)
            } else {
                countDownPageAction()
            }
        }
    }, [countDownPageAction, timer, counter])

    const buttonOutput =
        (buttonLink && buttonText && (
            <Button component={Link} to={buttonLink} variant="contained" color="primary">
                {buttonText}
            </Button>
        )) || (
            <>
                {buttonCallback && buttonText && (
                    <Button onClick={runCallback} variant="contained" color="primary">
                        {buttonText}
                    </Button>
                )}
                <Box display="flex" alignItems="center" mt={2} justifyContent="center">
                    {callbackStatus.error !== null ? (
                        <>
                            {callbackStatus.error ? (
                                <Alert severity="error">{callbackStatus.errMsg}</Alert>
                            ) : (
                                <Alert severity="success">{callbackStatus.successMsg || "success"}</Alert>
                            )}
                        </>
                    ) : null}
                </Box>
            </>
        ) ||
        null
    const countOutput = countMessage && (
        <Typography variant="p" component="p" style={{ marginBottom: "15px" }}>
            {`${countMessage} in ${counter} second(s)`}
        </Typography>
    )

    const outputMain = (
        <Box textAlign="center">
            <Typography variant="h5" component="h2" style={{ margin: "35px auto 15px", textTransform: "capitalize" }}>
                {messageOutput}
            </Typography>
            {subMessage && (
                <Typography variant="h6" component="p" style={{ marginBottom: "15px", textTransform: "capitalize" }}>
                    {subMessage}
                </Typography>
            )}
            {subMessageNormal && (
                <Typography component="p" style={{ marginBottom: "15px" }}>
                    {subMessageNormal}
                </Typography>
            )}
            {countDownPageAction && timer && countOutput}
            {buttonOutput}
        </Box>
    )
    return outputMain
}

export default ErrorAccess
